/* import React, { useState, useEffect } from "react";

const text = "This is a karaoke-style reading example where words are highlighted one by one.";

const KaraokeReading = () => {
  const words = text.split(" ");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev < words.length - 1 ? prev + 1 : prev));
    }, 500); // Adjust speed (500ms per word)

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ fontSize: "22px", lineHeight: "1.5", padding: "20px", textAlign: "center" }}>
      {words.map((word, i) => (
        <span key={i} style={{ color: i === index ? "red" : "black", fontWeight: i === index ? "bold" : "normal" }}>
          {word}{" "}
        </span>
      ))}
    </div>
  );
};

export default KaraokeReading; */

import React, { useState, useEffect,useRef } from "react";

const ChatGPTTypingEffect = ({ text, speed = 200 }) => {
  const words = text?.split(" ");
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const chatEndRef = useRef(null);
  useEffect(() => {
    if (index < words.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + " " + words[index]);
        setIndex(index + 1);
      }, speed);

      return () => clearTimeout(timeout);
    }
  }, [index, words, speed]);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [displayedText]);


  return  <div><div style={{ whiteSpace: "pre-line",width:'fit-content',padding:'10px 12px', background:'#F2F2F2', color:'#091E42', fontSize:'13px', fontWeight:'400',borderRadius:'20px 20px 20px 4px',textAlign:'left'}}>
           {displayedText}
  </div>
  <div ref={chatEndRef}></div>
  </div>;
};

export default ChatGPTTypingEffect;

